/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Smartlab_Irrigation_Error_Base_Url_InvalidInputs */

const vi_smartlab_irrigation_error_base_url_invalid = /** @type {(inputs: Smartlab_Irrigation_Error_Base_Url_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Địa chỉ máy chủ API tưới phải bắt đầu bằng http:// hoặc https://`)
};

/**

* @param {Smartlab_Irrigation_Error_Base_Url_InvalidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const smartlab_irrigation_error_base_url_invalid = /** @type {((inputs?: Smartlab_Irrigation_Error_Base_Url_InvalidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Smartlab_Irrigation_Error_Base_Url_InvalidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_smartlab_irrigation_error_base_url_invalid(inputs)
});